import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

import NavItem from './components/NavItem';

interface Props {
  pages: {
    landings: Array<PageItem>;
    company: Array<PageItem>;
    account: Array<PageItem>;
    secondary: Array<PageItem>;
    blog: Array<PageItem>;
    portfolio: Array<PageItem>;
  };
}

const SidebarNav = ({ pages }: Props): JSX.Element => {
  const theme = useTheme();
  const { mode } = theme.palette;

  const {
    company: companyPages,
    account: accountPages,
    secondary: secondaryPages,
  } = pages;

  return (
    <Box>
      <Box width={1} paddingX={2} paddingY={1}>
        <Box
          display={'flex'}
          component="a"
          href="/"
          title="Docket"
          width={{ xs: 100, md: 120 }}
        >
          <Box
            component={'img'}
            src={mode === 'light' ? '/assets/logo.png' : '/assets/logo-lightblue.png'}
            height={1}
            width={1}
          />
        </Box>
      </Box>
      <Box paddingX={2} paddingY={2}>
        {companyPages.length > 0 && (
          <Box>
            <NavItem title={'Company'} items={companyPages} />
          </Box>
        )}
        {secondaryPages.length > 0 && (
          <Box>
            <NavItem title={'Support'} items={secondaryPages} />
          </Box>
        )}
        {accountPages.length > 0 && (
          <Box>
            <NavItem title={'Account'} items={accountPages} />
          </Box>
        )}
        <Box marginTop={2}>
          <Button
            size={'large'}
            variant="contained"
            color="primary"
            fullWidth
            component="a"
            href="/login"
          >
            Login
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarNav;
